import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const COOKIE_CONSENT_KEY = 'maisoneclat_cookie_consent';

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-oxblood-darker border-t border-brass/20 shadow-lg">
      <div className="max-w-7xl mx-auto px-6 py-6 md:py-8">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 md:gap-6">
          <div className="flex-1">
            <p className="text-ivory-muted text-sm leading-relaxed">
              We use essential cookies to ensure our website functions properly, and optional cookies to analyse site usage and improve your experience. You may accept or reject non-essential cookies.{' '}
              <Link to="/cookies" className="text-brass hover:text-parchment transition-colors duration-300 underline">
                Learn more
              </Link>
            </p>
          </div>
          <div className="flex items-center gap-3 w-full md:w-auto">
            <button
              type="button"
              onClick={handleReject}
              className="flex-1 md:flex-none border border-brass/40 text-ivory-muted px-6 py-2.5 text-xs tracking-widest hover:bg-brass/5 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              REJECT
            </button>
            <button
              type="button"
              onClick={handleAccept}
              className="flex-1 md:flex-none bg-brass text-espresso px-6 py-2.5 text-xs tracking-widest hover:bg-brass/90 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              ACCEPT
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
